import { MedicalInformationType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

const CATEGORY_SLUG_BY_TYPE: Record<MedicalInformationType, string> = {
   CHRONIC_DISEASE: 'choroby-przewlekle',
   GYNECOLOGICAL_INTERVIEW: 'wywiad-ginekologiczny',
   DIAGNOSIS: 'rozpoznania',
   MEDICAL_IMAGING: 'badania-obrazowe',
   ALLERGY: 'uczulenia',
   ANTHROPOMETRY: 'antropometria',
   RISK_FACTOR: 'czynniki-ryzyka',
   HOSPITALIZATION: 'hospitalizacje',
   MEDICAL_CONSULTATION: 'konsultacje',
   REHABILITATION: 'rehabilitacja',
   REFERRAL: 'skierowania',
   ANALYTICAL_TEST_RESULT: 'wyniki-badan',
   TREATMENT: 'leczenie',
   OTHER: 'inne',
};

const TYPE_BY_CATEGORY_SLUG: Record<string, MedicalInformationType> = Object.entries(CATEGORY_SLUG_BY_TYPE).reduce(
   (result, [type, slug]) => {
      result[slug] = type as MedicalInformationType;
      return result;
   },
   {} as Record<string, MedicalInformationType>
);

export const getMedicalInformationTypeByCategorySlug = (slug: string | undefined): MedicalInformationType | undefined =>
   slug === undefined ? undefined : TYPE_BY_CATEGORY_SLUG[slug];
